<script lang="ts">
import { defineBlock } from '@bagelink/blox'
import { defineSchema } from '@bagelink/vue'
const defaults = {
	subtitle: '<b>Our mission</b> at the Academic Torah Institute is to democratize scholarship on the Bible and foundational Jewish texts—making it accessible, relevant, and compelling for readers from all backgrounds.',
	description: '<b>We believe</b> that knowledge-driven, intellectually honest engagement with tradition is essential to cultivating a more tolerant and educated society for generations to come.',
}
const schema = defineSchema({
	subtitle: $.richtext('Mission Statement', { basic: true }),
	description: $.richtext('Vision Statement', { basic: true }),
})
export const Hero = defineBlock({ name: 'Hero', label: 'Hero Section', icon: 'panorama', order: 2, schema, defaults })
</script>
<script setup lang="ts">

import { $ } from '@bagelink/vue'
const myData = defineProps<{
	subtitle?: string
	description?: string
}>()
</script>

<template>
	<article id="hero" class="w660px mx-auto pb-4 m_pb-2 m_px-1 txt-center">
		<div class="pt-3 pb-4 m_py-2">
			<img src="@/assets/ati-logo.svg" alt="Academic Torah Institute" class="h90px m_h50px">
		</div>
		<div class="flex gap-1-5 m_gap-1 align-items-start  m_px-1">
			<img src="@/assets/higher-education-icon.svg" alt="higher education Image" class="h40px mt-05">
			<div class="w660px txt-start" v-html="myData.subtitle" />
		</div>
		<div class="line w200px mx-auto my-2 m_w100px" />
		<div class="flex gap-1-5 m_gap-1 align-items-start  m_px-1">
			<img src="@/assets/plant-icon.svg" alt="plant image" class="h40px mt-05">

			<div class="w660px txt-start" v-html="myData.description" />
		</div>
	</article>
</template>
